import { render, staticRenderFns } from "./TabelaMateriaisProtocolo.vue?vue&type=template&id=315cfd64&scoped=true&"
import script from "./TabelaMateriaisProtocolo.vue?vue&type=script&lang=js&"
export * from "./TabelaMateriaisProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMateriaisProtocolo.vue?vue&type=style&index=0&id=315cfd64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315cfd64",
  null
  
)

export default component.exports